import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import BredcomSlider from '../Bredcom/MainSlider'
import NewMain from '../headerone/newMain'
function LifeAtMvn() { 
  return (
    <>
      <NewMain /> 
      <BredcomSlider title="Home" subtitle="Life At MVN" />
      
      <section>
          <div className='container'>
              {/* <div className='mvn_imse'> 
                  <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/life_mvn_banner.jpg`}  alt="img" className="vc-img" />
              </div> */}
<br /><br />
              <div className='mvn_imse_omse'> 
                <h3 className='new_title'>VIBRANT CAMPUS LIFE</h3>
                <p>Our campus is a hub of activity, offering a perfect blend of academic. From lively student gatherings to serene study spots, there’s a place for everyone. Our green lawns, modern infrastructure, and welcoming environment make MVN University a home away from home.</p>
                 <div className='row'>
                    <div className='col-md-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/lifeimgbanner.jpg' />
                        </div>
                    </div>
                </div>
                {/* <div className='row'>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/lifeimg1.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/lifeimg2.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/lifeimg3.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/lifeimg4.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/lifeimg5.jpg' />
                        </div>
                    </div>
                </div> */}
              </div>

<br />
              <div className='mvn_imse_omse'>
                <h3 className='new_title'>CULTURAL DIVERSITY</h3>
                <p>MVN University is a melting pot of cultures and traditions. Our diverse student body brings together individuals from different backgrounds, fostering a rich cultural exchange. Festivals, cultural nights, and international student events are an integral part of campus life, celebrating the uniqueness and unity of our community.</p>
                <p><b>ENVISAGE 2k25 Annual Fest</b></p>
                <div className="row">
                    <div className='col-md-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/festcollarge.jpg' />
                        </div>
                    </div>
                </div>
                {/* <div className='row'>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest1.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest2.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest3.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest4.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest5.jpg' />
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-4 xol-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest6.jpg' />
                        </div>
                    </div>
                </div> */}
                <p>MVN Universty celebrate its 9th convocation ceremony joined by the chief guest SH. Gourav Goutam, Hon’ble Minister of Youth Empowerment & Enterprenureship, sports, Law & Legislative, govt. Of Haryana and Dr. Rakesh Gupta , Chairman of  Sarvodaya Hospital, Faridabad. </p>
                {/* <div className='row'>
                    <div className='col-md-8 col-sm-8 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/fest7.jpg' />
                        </div>
                    </div>
                </div> */}
              </div>
                <br />

              <div className='mvn_imse_omse'>
                  <h3 className='new_title'>Glimpses of Freshers Party : </h3>
                  <p>Mr. Fresher Award goes to Mr. Christopher SBMC<br />
                  Ms. Fresher award goes to Ms. Arpita from SOET</p>
                  <div className='row'>
                    <div className='col-md-8'>
                        <div className='lifeimg'>
                            <img src='/assets/img/glimpscollarge.jpg' />
                        </div>
                    </div>
                   </div> 
                  {/* <div className='row'>
                    <div className='col-md-6'>
                        <div className='lifeimg'>
                            <img src='/assets/img/glimps1.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='lifeimg'>
                            <img src='/assets/img/glimps2.jpg' />
                        </div>
                    </div>
                </div> */}
              </div>

                <br />
              <div className='mvn_imse_omse'>
                <h3 className='new_title'>ACADEMIC EXCELLENCE</h3>
                <p>At MVN University, we are committed to academic excellence. Our state-of-the-art classrooms, well-equipped laboratories, and extensive library resources create an ideal learning environment. Our experienced faculty members are dedicated to mentoring and guiding students, helping them achieve their academic and professional goals.</p>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='lifeimg'>
                            <img src='/assets/img/aecolarge.jpg' />
                        </div>
                    </div>
                </div>
                {/* <div className='row'>
                    <div className='col-md-6'>
                        <div className='lifeimg'>
                            <label>Seminar Lecture by Mr. Narender Mendiratta, CEO of Unique ERP, on SAP Software</label>
                            <img src='/assets/img/ae1.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='lifeimg'>
                            <label>Celebration on Azure Developer Day With Microsoft (7Jan 2025 ) Speakers : Ms. Shweta Yadav & Ms. Rashi Jalal</label>
                            <img src='/assets/img/ae2.jpg' />
                        </div>
                    </div>
                </div> */}
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='lifeimg'>
                            <label>Enlightening visit to the Translational Health Science and Technology Institute (THSTI), Faridabad</label>
                            <p>On 14th oct 2024, BMLT students had an enlightening visit to the Translational Health Science and Technology Institute (THSTI), Faridabad. The visit provided them with an opportunity to explore cutting-edge healthcare research, bridging the gap between theoretical knowledge and practical applications.</p>
                        </div>
                    </div>
                </div>
              </div>


              <div className='mvn_imse_omse'>
                <h3 className='new_title'>Insightful Industrial Visit to CodeSquadz</h3>
                <p>On 7th November 2024, a group of 30 students from the BCA and B.Tech programs at the School of Engineering and Technology embarked on an insightful industrial visit to CodeSquadz, a leading software development company located in Noida, Uttar Pradesh. The visit was an integral part of the university’s industrial tour, designed to provide students with a firsthand look at the operations of a professional IT firm. During the visit, students had the opportunity to explore CodeSquadz’s approach to technology and learn about their innovative solutions in areas such as mobile app development, web development, and cloud computing.</p>
                {/* <div className='row'>
                    <div className='col-md-8 col-sm-8 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/insightful1.jpg' />
                        </div>
                    </div>
                </div> */}
              </div>
              <br />
               <div className='mvn_imse_omse'>
                <h3 className='new_title'>Workshop  Maya Academy of Advanced Creativity (MAAC) is India’s leading training institute for High-End 3D Animation and Visual Effects. </h3>
                <p>On 7th November 2024, a group of 30 students from the BCA and B.Tech programs at the School of Engineering and Technology embarked on an insightful industrial visit to CodeSquadz, a leading software development company located in Noida, Uttar Pradesh. The visit was an integral part of the university’s industrial tour, designed to provide students with a firsthand look at the operations of a professional IT firm. During the visit, students had the opportunity to explore CodeSquadz’s approach to technology and learn about their innovative solutions in areas such as mobile app development, web development, and cloud computing.</p>
                {/* <div className='row'>
                    <div className='col-md-8 col-sm-8 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/insightful2.jpg' />
                        </div>
                    </div>
                </div> */}
              </div>
              <br />
              <div className='mvn_imse_omse'>
                <h3 className='new_title'>5. Mock-Interview Session for Students</h3>
                <p>On 4th October 2024, MVN University organized a Mock Interview session for the final-year students of B.Pharm, BBA, MBA, B.Com, and B.Tech programs. The session was designed to prepare students for real-world job interviews by simulating the actual interview experience.</p>
                
                {/* <div className='row'>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/insightful3.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/insightful4.jpg' />
                        </div>
                    </div>
                    <div className='col-md-8 col-sm-8 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/insightful5.jpg' />
                        </div>
                    </div>
                </div> */}
                <p>On 26th November 2024, the <b>School of Law</b> at MVN University celebrated National Constitution Day, marking the adoption of the Indian Constitution. The event was graced by the presence of Ms. Mainka Singh, Chief Judicial Magistrate cum Secretary of DLSA Palwal, Haryana, who was the esteemed Chief Guest for the occasion. The celebration included an informative session highlighting the significance of the Indian Constitution, its historical context, and its impact on the nation’s legal and social framework. The Chief Guest emphasized the importance of understanding and upholding the Constitution, urging students to recognize their role in promoting justice and equality in society.</p>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='lifeimg'>
                            <img src='/assets/img/insightfulbanner.jpg' />
                        </div>
                    </div>
                </div>
              </div>

<br />
              <div className='mvn_imse_omse'>
                  <h3 className='new_title'>COMMUNITY ENGAGEMENT</h3>
                  <p>At MVN University, we are committed to making a positive impact on society. Our students actively participate in community service and outreach programs, contributing to social causes and community development. These experiences develops a sense of responsibility and empathy, preparing students to be compassionate leaders.</p>
                <p>Mvn University celebrated World Health Day in collaboration with the IPGA Palwal Local Chapter, emphasizing the importance of health and well-being. The event aimed to raise awareness about maintaining a healthy  Lifestyle and promoting community Wellness.</p>
                
                {/* <div className='row'>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity1.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity2.jpg' />
                        </div>
                    </div>
                    <div className='col-md-8 col-sm-8 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity3.jpg' />
                        </div>
                    </div>
                </div> */}
                <p><b>2. Free Eye Check-up in collaboration with Niramaya Charitable Trust and Ahuja Eye and Dental Institute, Gurugram.</b> On 9th October 2024, MVN University showcased its dedication to community welfare by organizing a Free Eye Check-up in collaboration with Niramaya Charitable Trust and Ahuja Eye and Dental Institute, Gurugram. Simultaneously, a comprehensive health checkup was held in partnership with Divine Charitable Trust under the guidance of Dr. N.P. Sharma. Both initiatives were lauded by participants for their impactful contributions to local healthcare.</p>
                {/* <div className='row'>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity4.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity5.jpg' />
                        </div>
                    </div>
                </div> */}
                <p><b>3. Free Health Check-up camps across various locations in Palwal on 19th December 2024, in honor of the birth anniversary of the founder of MVN Society, Late Sh. Gopal Sharma Ji</b> On 19th December 2024, in honor of the birth anniversary of the founder of MVN Society, Late Sh. Gopal Sharma Ji, MVN University organized a series of Free Health Check-up camps across various locations in Palwal. The camps were held near prominent landmarks, including Laxmi Narayan Mandir, Gurudwara Sahib Palwal, Bamnikhera, Banchari, Mitrol, Arungabad, Sarai Khatela, and several other areas. This noble initiative was conducted in collaboration with esteemed healthcare providers such as Pulse Hospital, Tula Hospital, SKR Hospital, Simran Hospital, Apex Hospital, Accord Hospital, and KC Prashant Path Lab. The camps offered free general health consultations and services to local residents, who expressed gratitude for the opportunity to access quality healthcare at no cost. The event reflected the university’s commitment to community welfare, paying tribute to the founder's legacy by promoting health and well-being across the region.</p>
                {/* <div className='row'>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity6.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity7.jpg' />
                        </div>
                    </div>
                </div> */}
                <p>4. MVN University, School of Pharmacuetical Sciences, celebrate 63rd National Pharmacy  week by Blood Donation camp at campus on in association with <b>“Divine Blood Charitable  Centre”</b> on 26th November 2024.  </p>
                {/* <div className='row'>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity8.jpg' />
                        </div>
                    </div>
                    <div className='col-md-6 col-sm-6 col-xs-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunity9.jpg' />
                        </div>
                    </div>
                </div> */}
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='lifeimg'>
                            <img src='/assets/img/sommunitybanner.jpg' />
                        </div>
                    </div>
                </div>
              </div>

                <br />
                <div className='mvn_imse_omse'>
                  <h3 className='new_title'>EXTRACURRICULAR ACTIVITIES</h3>
                  <p>1 .On October 7, 2024, a team of BBA 3rd-semester students from SBMC – Kanshika, Dimple, Muskan, and Megha – participated in the event "Redefining Future: Linking AI with Healthcare" organized by Manav Rachna University. Their innovative presentation secured them the fourth position, showcasing their analytical and creative thinking skills.</p>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activitiesbanner.jpg' />
                            </div>
                        </div>
                    </div>
                    {/* <div className='row'>
                        <div className='col-md-8 col-sm-8 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities1.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p>2. On October 18, 2024, MVN students displayed exceptional talent at Rawal College, Faridabad. Arjun (BALLB) participated in the arm-wrestling competition and performed commendably. Numan (BALLB) clinched the first prize in the chess competition.</p>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activitiesbanner1.jpg' />
                            </div>
                        </div>
                    </div>
                    {/* <div className='row'>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities2.jpg' />
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities3.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p>4 On October 19, 2024, <b>Jabir</b>, a student of <b>BA Political Science (Honours)</b>, brought pride to MVN University by securing the <b>1st rank</b> at Lingaya’s Vidyapeeth University’s annual fest, <b>“ZEST – 2K24.”</b> His outstanding performance and dedication stood out among the participants, showcasing the excellence and talent of MVN students on a prestigious platform.</p>
                    {/* <div className='row'>
                        <div className='col-md-8 col-sm-8 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities4.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p>5. Ishwar (B.Pharma) emerged as a double champion, securing first place in both the shotput and discus throw events. On November 23, 2024, the MVN football team competed at SGT University, Gurugram, where they displayed exceptional teamwork and skill. Their efforts earned them the second position in the tournament, a testament to their hard work and dedication. On December 25, 2024.</p>
                    {/* <div className='row'>
                        <div className='col-md-8 col-sm-8 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities5.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p>6. On October 22 and 23, 2024, MVN students showcased their exceptional talent at Manav Rachna University, Faridabad. The ramp walks participants delivered a stellar performance, earning the <b>Best Performance Award</b>. Each participant was honoured with <b>16 gold coins and certificates</b>, a testament to their dedication and creativity. Adding to the accolades, on <b>October 23, Hiten (BBA-LLB)</b> secured the <b>Third Prize in the Monologue Competition</b>, impressing the audience and judges with his captivating delivery. These achievements highlight the remarkable skills and versatility of MVN students.</p>
                    {/* <div className='row'>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities6.jpg' />
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities7.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p>7. On 25th October 2024, the "Diwali Milan Samaroh" brought together principals from schools across Palwal, Faridabad, and Gurugram. Discussions revolved around MVN University's dedication to quality education and innovative teaching methodologies, fostering meaningful collaborations with regional educational leaders.</p>
                    {/* <div className='row'>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities8.jpg' />
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities9.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p>8. On December 25, 2024, during an event organized by the Association of Indian Universities(AIU) at Gurukashi University, Bathinda, Punjab, <b>Pankaj (BBA)</b> delivered an impressive performance in <b>boxing</b> and advanced to the third round. His determination and resilience were truly inspiring.</p>
                    {/* <div className='row'>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities10.jpg' />
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities11.jpg' />
                            </div>
                        </div>
                    </div> */}
                    <p><b>9. National Fit India Week:</b> From 20th to 24th December 2024, as part of the National Fit India initiative, the university conducted a week-long celebration promoting physical fitness and mental health. Students and staff enthusiastically participated in activities such as yoga, fitness challenges, and awareness sessions, reinforcing the importance of a healthy lifestyle.</p>
                    {/* <div className='row'>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities12.jpg' />
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='lifeimg'>
                                <img src='/assets/img/activities13.jpg' />
                            </div>
                        </div>
                    </div> */}
                </div>

          </div>
      </section>




    </>
  )
}

export default LifeAtMvn